<template>
  <div class="head-tool">
    <div class="side-switch" @click="toggleSide" :class="{ 'trans-rotate': !sidebarOpen }">
      <i class="iconfont icon-bars"></i>
    </div>
    <div class="app-name">{{ appName }}</div>
    <div class="right-menu">
      <div class="right-menu-item" style="margin-right: 8px">欢迎您: {{ username }}</div>
      <el-dropdown class="avatar-container right-menu-item hover-effect" trigger="click">
        <div class="avatar-wrapper">
          <img :src="avatar || '/static/imgs/base_avatar.png'" class="user-avatar">
          <i class="iconfont icon-xialaxuanze"></i>
        </div>
        <el-dropdown-menu slot="dropdown" class="menu contentSettingDropdown">
          <router-link to="/">
            <el-dropdown-item>首页</el-dropdown-item>
          </router-link>
          <el-dropdown-item divided>
            <span style="display:block;" @click="logout">退出登录</span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'NavBar',
  computed: {
    appName: function() {
      return this.$store.state.app.appName
    },
    ...mapGetters(['avatar', 'username', 'sidebarOpen'])
  },
  methods: {
    toggleSide: function() {
      this.$store.dispatch('toggleSideBar')
    },
    logout() {
      this.$store.dispatch('InvalidToken')
    }
  }
}
</script>

<style scoped lang='scss'>
.head-tool {
  padding: 5px 0;
  height: 100%;
}
.trans-rotate {
  transform: rotate(90deg);
}
.app-name {
  font-size: 20px;
  font-weight: 600;
  line-height: 40px;
  float: left;
  font-weight: bold;
  font-family: PingFangSC-Regular, PingFang SC;
}
.side-switch {
  float: left;
  padding: 5px 0;
  margin-right: 20px;
}
.side-switch i {
  font-size: 20px;
  line-height: 30px;
  cursor: pointer;
}
.side-switch:hover {
  color: #66b1ff;
}
.right-menu {
  float: right;
  height: 100%;
  line-height: 40px;
}
.right-menu:focus {
  outline: none;
}
.right-menu-item {
  display: inline-block;
  height: 100%;
  font-size: 14px;
  color: #333;
  vertical-align: text-bottom;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: normal;
}
.hover-effect {
  cursor: pointer;
  transition: background 0.3s;
}
.hover-effect:hover {
  background: rgba(0, 0, 0, 0.025);
}
.avatar-wrapper i {
  font-size: 12px;
}
.user-avatar {
  cursor: pointer;
  width: 30px;
  height: 30px;
  border-radius: 10px;
  margin-top: 4px;
  /*overflow: hidden;*/
  /*padding: 5px;*/
}
.menu {
  overflow: initial;
}
</style>



// WEBPACK FOOTER //
// src/views/layout/Header/NavBar.vue